<template>
  <div>
    <vs-button @click="showDialog = true">Open Chat</vs-button>

    <vs-dialog class="chat-dialog" v-model="showDialog">
      <template #header>
        <h1 class="dialog-title">{{ `PO${orderID}` }} <b>Chat</b></h1>
      </template>

      <div class="chat-feed">
        <div class="chat-message" v-if="messages.length === 0">
          <b>Open PO: </b> There are no messages in this chat yet.
        </div>

        <div class="chat-message" v-for="message in messages" :key="message.id">
          <b>{{ `${message.user_name}: ` }}</b> {{ message.content }}
        </div>
      </div>

      <template #footer>
        <form class="chat-form" @submit.prevent="createMessage">
          <vs-input placeholder="What's on your mind..." v-model="message" />
        </form>
      </template>
    </vs-dialog>
  </div>
</template>

<script>
import twitter from 'twitter-text';
import axios from 'axios';
import supabase from '../supabase';

export default {
  name: 'Chat',

  data() {
    return {
      message: '',
      showDialog: false,
      messages: [],
    };
  },

  computed: {
    orderID() {
      return this.$route.params.orderID;
    },
  },

  async created() {
    this.showDialog = this.$route.query.chat === 'true';

    const messages = await supabase
      .from('messages')
      .filter('order_id', 'eq', this.orderID)
      .order('inserted_at')
      .select('id, user_name, content');

    this.messages = messages.body;

    this.subscription = await supabase
      .from('messages')
      .filter('order_id', 'eq', this.orderID)
      .on('INSERT', (payload) => {
        this.messages.unshift(payload.new);
      }).subscribe();
  },

  methods: {
    async createMessage() {
      try {
        if (this.message.replace(/\s/g, '') !== '') {
          const mentions = twitter.extractMentions(this.message);

          if (this.messages.length > 0 && this.messages[0].user_name.toUpperCase() !== this.$store.state.user.user_metadata.name.toUpperCase()) {
            mentions.push(this.messages[0].user_name);
          }

          await supabase
            .from('messages')
            .insert([
              {
                order_id: this.orderID,
                user_name: this.$store.state.user.user_metadata.name,
                content: this.message,
              },
            ]);

          this.message = '';

          if (mentions.length > 0) {
            await axios.post(process.env.VUE_APP_MENTIONS_URL, {
              mentions: mentions,
              order_id: this.orderID,
            });
          }
        }
      } catch (error) {
        alert(error.message);
      }
    },
  },

  beforeDestroy() {
    this.subscription.unsubscribe();
  },
};
</script>
